// @flow

import * as React from 'react'
import styled, { css } from 'styled-components'
import styles from './styles.scss'
import { Paper } from '@/components'

const {
  orange4,
  black,
  bigButtonHeight,
  white,
  boxShadowRight,
  boxShadowBottom,
  paperBoxShadow,
} = styles

type TabData = {|
  activeAccessory: React.Node,
  inactiveAccessory: React.Node,
  title: string,
  content: React.Node,
  className?: string,
  noPaper?: boolean,
|}

type TabsProps = {|
  tabs: Array<TabData>,
  style?: Object,
  initialTab?: ?number,
  onClick?: ?(value: number) => void,
|}

type TabsState = {|
  activeTab: number,
|}

const Tab = styled.button`
  background: ${white};
  height: ${bigButtonHeight};
  span {
    margin: auto;
    color: ${black};
  }
  box-shadow: 0 ${boxShadowRight} ${boxShadowBottom} 0 ${paperBoxShadow};
  ${props =>
    props.isActive &&
    css`
      background: ${orange4};
      span {
        color: ${white};
      }
    `}
`
const Div = styled.div``

export class Tabs extends React.Component<TabsProps, TabsState> {
  static defaultProps = {
    initialTab: null,
    onClick: null,
    style: {},
  }

  constructor(props: TabsProps) {
    super(props)

    const { initialTab } = props
    let activeTab = 0
    if (typeof initialTab === 'number') {
      activeTab = initialTab
    }

    this.state = {
      activeTab,
    }
  }

  updateActiveTab = (activeTab: number) => {
    this.setState({ activeTab })
  }

  onClick = (activeTab: number) => {
    const { onClick } = this.props
    if (onClick) {
      onClick(activeTab)
    }
    this.updateActiveTab(activeTab)
  }

  getTabs = (): ?Array<React.Node> => {
    const { tabs } = this.props
    const { activeTab } = this.state

    return tabs.map((item, idx) => (
      <Tab
        key={item.title}
        isActive={activeTab === idx}
        onClick={this.onClick.bind(this, idx)} // eslint-disable-line react/jsx-no-bind
        name={`tab-${idx}`}
        className={item.className}
      >
        {activeTab === idx
          ? this.renderAccessory(item.activeAccessory)
          : this.renderAccessory(item.inactiveAccessory)}
        <span>{item.title}</span>
      </Tab>
    ))
  }

  renderAccessory = (accessory: React.Node) => (
    <section>
      <div>{accessory}</div>
    </section>
  )

  render() {
    const { tabs, style } = this.props
    const { activeTab } = this.state
    const { content, noPaper } = tabs[activeTab]
    const Wrapper = noPaper ? Div : Paper
    return (
      <div>
        <div className={styles.tabs} style={style}>
          {this.getTabs()}
        </div>
        <Wrapper className={styles.tabContent}>{content}</Wrapper>
      </div>
    )
  }
}

export default Tabs
